const toggleAriaHidden = function(_swiper, debug) {
  const swiper = _swiper || null
  if (!!swiper) {
    if (debug) {
      console.log(swiper.slides)
    }
    Object.keys(swiper.slides).forEach(function(key) {
      if ($(swiper.slides[key]).is('.swiper-slide-visible')) {
        $(swiper.slides[key]).removeAttr('aria-hidden')
        $(swiper.slides[key]).find('a, button').removeAttr('tabindex')
      } else {
        $(swiper.slides[key]).attr('aria-hidden', 'true')
        $(swiper.slides[key]).find('a, button').attr('tabindex', '-1')
      }
    })
    return
  }
}

export default { toggleAriaHidden }